module.exports = __webpack_public_path__ + "img/5.1b8fc643.jpg";